import React, { useEffect, useRef, useState } from "react";

/** Libraries */
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

/** Components */
import { fadeIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

/** style */
import "../../../Assets/scss/MedicalCounsellingIndia/pages/home.scss";
import CommonContactButton from "../../Components/AnotherButton/CommonContactButton";
import MetaTags from "../../Components/MetaTags";
import "./DirectAdmissionInBptInPune.scss";

/** top college details */


function DirectAdmissionInBptInPune() {
  const [formLoading, setFormLoading] = useState(false);
  const collegeSectionRef = useRef(null);
  const location = useLocation();

  // const collegeTitle = collegeName
  // .split("-")
  // .map((curElem) => {
  //   if (exceptions.includes(curElem)) return curElem;
  //   return curElem.charAt(0).toUpperCase() + curElem.slice(1);
  // })
  // .join(" ");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    console.log(data);
    setFormLoading(true);
    toast.success("Your message has been sent successfully!", {
      theme: "colored",
    });

    setTimeout(() => {
      setFormLoading(false);
    }, 1000);
  };

  const handleKeyDown = (event) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    const isNumberKey = !isNaN(Number(event.key)) && event.code !== "Space";

    if (!allowedKeys.includes(event.code) && !isNumberKey) {
      event.preventDefault();
    }
  };

  /** scroll to college */

  useEffect(() => {
    if (
      location.search.includes("scrollToCollege=true") &&
      collegeSectionRef.current
    ) {
      collegeSectionRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("hi");
    }
  }, [location.search]);

  return (
    <>
      <MetaTags
        title="Direct Admission in BPT in Pune | Top Physiotherapy Colleges 2025"
        description="Call or WhatsApp Counselling India at 9730858444 to book your BPT seat at DY Patil College of Physiotherapy now!"
        keywords=" Direct Admission in BPT in Pune,  Admission in BPT in Pune 2025, Direct Admission in BPT Course, "
      />

      {/* banner Parallax Scrolling End */}

      {/* instruction section start  */}
      <section className="bg-lightgray py-[150px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[100px]">
        <Container>
          {/* How to get Admission */}
          <div className="">
            <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none text-center">
              Direct Admission in BPT in Pune, Dr. DY Patil College of
              Physiotherapy – Complete Admission Guide
            </h1>

            <m.div
              className="portfolio-boxed overflow-hidden"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <div className="portfolio-image relative mx-auto ">
                <img
                  className="w-full"
                  src={
                    "/assets/img/webp/MedicalCounsellingIndia/direct-admission-college/BptInPune.png"
                  }
                  height={447}
                  width={550}
                  alt="portfolio-boxed"
                />
              </div>
            </m.div>
            <div>
              <div className="!text-[#616162] mt-4  ">
                <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-normal">
                  Build a Future in Physiotherapy
                </h1>
                <div className="mt-3">
                  Physiotherapy is one of the most dynamic and growing fields in
                  healthcare today. With increasing awareness of physical
                  wellness and rehabilitation, the demand for qualified
                  physiotherapists is rising rapidly. If you're planning to
                  pursue a <b>Bachelor of Physiotherapy (BPT)</b> and want to
                  study in one of India’s top institutions, Direct Admission in{" "}
                  <b>BPT in Pune</b> ,{" "}
                  <b> Dr. DY Patil College of Physiotherapy</b> is an excellent
                  opportunity.
                </div>
                <div className="mt-3">
                  Located in Pimpri, Pune,{" "}
                  <b> Dr. DY Patil College of Physiotherapy </b>
                  is part of the renowned DY Patil Group. The college is known
                  for its world-class infrastructure, experienced faculty, and
                  exceptional clinical training. Through direct admission,
                  eligible students can bypass competitive entrance exams and
                  secure a seat in this reputed institution quickly and
                  efficiently.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <CommonContactButton />
          </div>

          {/* general eligibility */}
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Choose Dr. DY Patil College of Physiotherapy, Pune?
            </h2>
            <div>
              <p className="!text-[#616162]">
                <b> Dr. DY Patil College of Physiotherapy</b> is one of the best
                physiotherapy colleges in India, affiliated with Dr. DY Patil
                Vidyapeeth (Deemed to be University). It offers a comprehensive
                BPT program supported by cutting-edge facilities, practical
                training, and research exposure.
              </p>
            </div>
            <div>
              <h3 className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px] mb-3 leading-none mt-4">
                Key Highlights:
              </h3>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>NAAC Accredited with ‘A++’ Grade</li>
                <li>
                  Recognized by UGC and approved by the Indian Association of
                  Physiotherapists (IAP)
                </li>
                <li>
                  100+ beds attached to the DY Patil Hospital for clinical
                  practice
                </li>
                <li>
                  Dedicated departments for orthopedics, neurology,
                  cardiopulmonary, sports, and pediatric physiotherapy
                </li>
                <li>
                  International collaborations and MOUs with global universities
                </li>
                <li>
                  Advanced rehabilitation labs and simulation-based learning
                </li>
              </ol>

              <div className="mt-2">
                <p className="!text-[#616162]">
                  Pursuing <b>Direct Admission in BPT in Pune</b>, Dr. DY Patil
                  College of Physiotherapy ensures that you learn from the best
                  in a student-centric environment that emphasizes academic
                  rigor and hands-on training.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              What is Direct Admission in BPT?
            </h2>
            <div>
              <p className="!text-[#616162]">
                <b>Direct admission </b>refers to the process of gaining entry
                into a professional course like BPT without going through state
                or national-level entrance exams. At<b>Dr. DY Patil College</b>{" "}
                of Physiotherapy, a limited number of seats are available under
                the <b>management quota</b> . These are allocated based on
                academic performance, documentation, and early application – not
                competitive test scores.
              </p>
              <p className="mt-3">
                With <b>Counselling India</b>, students can smoothly apply for{" "}
                <b>Direct Admission in BPT in Pune</b> ,{" "}
                <b>Dr. DY Patil College of Physiotherapy</b> , ensuring proper
                guidance, documentation support, and timely seat allotment.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Eligibility Criteria for BPT Admission at DY Patil College, Pune
            </h2>
            <div>
              <p className="!text-[#616162]">
                To be eligible for Direct Admission in BPT in Pune, Dr. DY Patil
                College of Physiotherapy, you must meet the following
                requirements:
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>Educational Qualification:</b> 10+2 or equivalent with
                  Physics, Chemistry, and Biology as main subjects.
                </li>
                <li>
                  <b> Minimum Marks:</b> 50% aggregate in PCB (for general
                  category); 45% for SC/ST/OBC candidates.
                </li>
                <li>
                  <b>Age:</b> Minimum 17 years on or before 31st December of the
                  year of admission.
                </li>{" "}
                <li>
                  <b>Medical Fitness:</b>
                  Candidates must be medically fit and capable of undergoing
                  clinical training.
                </li>
              </ol>
              <p className="mt-2">
                <span className="italic">Note:</span> NEET is not mandatory for
                BPT admission through the management quota at DY Patil.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              BPT Program Structure at Dr. DY Patil College of Physiotherapy
            </h2>
            <div>
              <p className="!text-[#616162]">
                In conclusion, choosing the{" "}
                <b>Top Education Consultants in Jamshedpur , </b> like{" "}
                <b>Counselling India </b> , ensures a seamless academic journey
                with expert guidance at every step. Their in-depth knowledge of
                global education trends, university admissions, scholarships,
                and career planning helps students make informed decisions. With
                a student-centric approach, they provide personalized
                counseling, assisting in course selection, test preparation,
                visa processing, and financial aid opportunities.
              </p>
            </div>
            <div>
              <p className="!text-[#616162]">
                The <b>BPT program</b> at DY Patil is a{" "}
                <b>4.5-year undergraduate course</b> comprising 4 years of
                academic study followed by a 6-month compulsory clinical
                internship.
              </p>
              <h3 className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px] mb-3 leading-none mt-4">
                Core Subjects Include:
              </h3>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Anatomy & Physiology</li>
                <li>Biomechanics</li>
                <li>Pathology & Microbiology</li>{" "}
                <li>Exercise Therapy & Electrotherapy</li>
                <li>Orthopedic and Neurological Physiotherapy</li>
                <li>Cardiopulmonary Conditions</li>
                <li>Community-Based Rehabilitation</li>
                <li>Research Methodology & Evidence-Based Practice</li>
              </ol>
              <p className="mt-2">
                Students receive extensive training in hospital wards,
                outpatient departments, rehabilitation units, and sports
                clinics, providing the perfect blend of theory and practice.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Top Reasons to Choose Direct Admission at DY Patil Pune
            </h2>
            <div>
              <p className="!text-[#616162]">
                Choosing Direct Admission in BPT in Pune, Dr. DY Patil College
                of Physiotherapy offers multiple benefits:
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  {" "}
                  <b>No Competitive Exam Required:</b> Skip the stress of NEET
                  or state entrance exams.
                </li>
                <li>
                  {" "}
                  <b>Early Admission:</b> Get ahead of the crowd and secure your
                  seat before others.
                </li>{" "}
                <li>
                  {" "}
                  <b>Guaranteed Seat (Subject to Eligibility):</b> No waiting
                  lists or lottery systems.
                </li>
                <li>
                  {" "}
                  <b>Tailored Guidance:</b> With <b>Counselling India</b>,
                  receive end-to-end admission support.
                </li>
                <li>
                  <b>World-Class Learning:</b> Join one of the most respected
                  physiotherapy programs in India.
                </li>
              </ol>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Step-by-Step Admission Process – With Counselling India
            </h2>
            <div>
              <p className="!text-[#616162]">
                Securing Direct Admission in BPT in Pune, Dr. DY Patil College
                of Physiotherapy through Counselling India is simple, fast, and
                fully transparent
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b>Step 1: Contact Our Team</b>
                  <div>
                    📞 Call or WhatsApp us at 9730858444 for an initial
                    consultation.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 2: Profile Evaluation</b>
                  <div>
                    We review your academic background and suggest the best-fit
                    program options
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 3: Document Submission</b>
                  <div>
                    Submit scanned copies of your 10th and 12th mark sheets, ID
                    proof, and other required documents.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 4: Seat Confirmation</b>
                  <div>
                    We coordinate with the college to reserve your seat under
                    the management quota.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 5: Fee Payment</b>
                  <div>
                    Once approved, you’ll receive an admission letter and be
                    guided to make the fee payment.
                  </div>
                </li>{" "}
                <li className="mt-2">
                  <b>Step 6: Admission Finalization</b>
                  <div>
                    Receive your final admission confirmation, along with hostel
                    and orientation information.
                  </div>
                </li>{" "}
              </ol>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Documents Required for Admission
            </h2>
            <div>
              <p className="!text-[#616162]">
                Here’s the list of documents needed for
                <b>
                  Direct Admission in BPT in Pune, Dr. DY Patil College of
                  Physiotherapy:
                </b>
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>10th and 12th Marksheets & Certificates</li>{" "}
                <li>Transfer Certificate (TC) / School Leaving Certificate</li>
                <li>Migration Certificate (if from another board or state)</li>
                <li>Aadhaar Card or valid ID proof</li>
                <li>Passport-sized Photos (5–10 copies)</li>
                <li>Medical Fitness Certificate</li>
                <li>Caste Certificate (if applicable)</li>
                <li>Gap Certificate (if applicable)</li>
                <li>Birth Certificate</li>
              </ol>

              <p className="mt-3">
                We help you prepare and submit everything correctly to avoid
                delays.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              BPT Fee Structure at DY Patil College of Physiotherapy
            </h2>
            <div>
              <p className="!text-[#616162]">
                The fee structure at Dr. DY Patil College is competitive
                considering the premium facilities and reputation of the
                institution.
              </p>
            </div>

            <div>
              <b className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px] mb-2 leading-none mt-4">
                Estimated Annual Fee (Management Quota):
              </b>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  {" "}
                  <b>Tuition Fees:</b> ₹1,25,000 – ₹1,75,000
                </li>{" "}
                <li>
                  <b>Hostel & Mess Charges:</b> ₹80,000 – ₹1,00,000
                </li>
                <li>
                  <b>One-Time Admission Fees:</b> As per college norms
                </li>
                <li>
                  <b>Examination Fees</b> Payable as per university guidelines
                </li>
              </ol>

              <p className="mt-3">
                Counselling India provides complete fee breakdown and
                installment/payment options where applicable.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Scholarships and Financial Support
            </h2>
            <div>
              <p className="!text-[#616162]">
                While management quota admissions are generally not eligible for
                government scholarships, students can still explore:
              </p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>Educational Loans</b> from nationalized and private banks
                </li>{" "}
                <li>
                  <b>Private merit-based scholarships</b>
                </li>
                <li>
                  <b>DY Patil Group scholarships</b> (occasionally offered to
                  deserving candidates)
                </li>
                <li>
                  <b>Flexible payment plans </b>for annual or semester-wise fees
                </li>
              </ol>

              <p className="mt-3">
                Our counselors guide you through education loan processes and
                help with documentation.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Career Opportunities After BPT from DY Patil College
            </h2>
            <div>
              <p className="!text-[#616162]">
                Graduating from <b>Dr. DY Patil College of Physiotherapy</b>{" "}
                offers vast career opportunities both in India and abroad.
              </p>
            </div>

            <div>
              <div className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px]  leading-none mt-4">
                Job Roles:
              </div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Clinical Physiotherapist</li>
                <li>Sports Injury Specialist</li>
                <li>Neurological and Pediatric Therapist</li>
                <li>Orthopedic Physiotherapy Consultant</li>
                <li>Corporate Health Advisor</li>
                <li>Rehab Centre Consultant</li>
                <li>Physiotherapy Lecturer or Researcher</li>
              </ol>
              <div className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px]  leading-none mt-4">
                Employers:
              </div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Government & Private Hospitals</li>
                <li>Sports Academies and Gyms</li>
                <li>Wellness and Rehabilitation Centers</li>
                <li>Orthopedic Physiotherapy Consultant</li>
                <li>NGOs and Rural Health Missions</li>
                <li>Teaching Institutions and Universities</li>
              </ol>

              <p className="mt-3">
                With a degree from a respected college like DY Patil, your job
                prospects are strong both in India and internationally.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Counselling India is the Best Choice for Admission
            </h2>
            <div>
              <p className="!text-[#616162]">
                <b>Counselling India</b> is your trusted partner for secure and
                smooth
                <b>
                  Direct Admission in BPT in Pune, Dr. DY Patil College of
                  Physiotherapy
                </b>
              </p>
            </div>

            <div>
              <div className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px]  leading-none mt-4">
                Our Advantages:
              </div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  Years of experience with medical and paramedical admissions
                </li>
                <li>Direct collaboration with DY Patil University</li>
                <li>100% transparency – no hidden fees</li>
                <li>Orthopedic Physiotherapy Consultant</li>
                <li>Real-time updates and documentation support</li>
                <li>Personalized counselling and career guidance</li>
              </ol>
            </div>
            <p className="mt-3">
              We don’t just help you get in — we help you succeed.
            </p>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Frequently Asked Questions (FAQs)
            </h2>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b>
                    Q1: Is NEET required for BPT at Dr. DY Patil College of
                    Physiotherapy?
                  </b>
                  <div>
                    <b>No,</b> NEET is not mandatory for management quota
                    admissions in the BPT course.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Q2: How many seats are available for direct admission?</b>
                  <div>
                    Management quota seats are limited. Apply early to secure
                    your seat.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Q3: Are hostel facilities available on campus?</b>
                  <div>
                    Yes, fully furnished AC and non-AC hostels are available
                    with mess, Wi-Fi, and laundry.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Q4: Can I pay the BPT fees in installments?</b>
                  <div>
                    Yes, some flexibility is available. Speak with Counselling
                    India for structured payment plans.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Q5: When should I apply for admission?</b>
                  <div>
                    The best time to apply is immediately after your 12th
                    results are declared to avoid missing out.
                  </div>
                </li>{" "}
              </ol>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Conclusion: Secure Your Seat at Dr. DY Patil College Today
            </h2>

            <div>
              Pursuing{" "}
              <b>
                Direct Admission in BPT in Pune, Dr. DY Patil College of
                Physiotherapy{" "}
              </b>{" "}
              gives you the advantage of top-class education, hands-on clinical
              practice, and strong career prospects. With an excellent
              reputation and global recognition, this institution is your
              gateway to a successful career in physiotherapy.
            </div>
          </div>
        </Container>
      </section>

      {/* instruction section start  */}

      {/* top college details start*/}

      {/* enquiry form section start */}
      <m.section
        className="py-[160px] bg-cover 	bg-no-repeat overflow-hidden relative bg-center lg:py-[120px] md:py-[95px] xs:py-[80px] xxs:py-[50px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/MedicalCounsellingIndia/home/enquiry/enquiry.webp)",
        }}
        {...fadeIn}
      >
        <Container className="xs:px-0">
          <div className="flex justify-center mb-[100px] w-full">
            <p className="font-normal text-[20px] w-[70%] lg:w-[70%] md:w-[100%] text-center">
              Get Top Education Consultant in Jamshedpur. Kindly submit your
              data below and we shall connect you as soon as possible.
            </p>
          </div>
          <Row className="justify-end md:justify-center">
            <Col xl={7} lg={7} md={9} sm={11}>
              <div className="px-[3rem] py-[5rem] rounded-md shadow-[0_0_30px_rgb(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-[6rem]">
                <span className="mb-[15px] font-medium text-center text-[#f78c1f] text-md font-serif uppercase block sm:mb-[10px]">
                  Submit your details here
                </span>
                <h5 className="w-[80%] mb-[40px] font-bold text-center	tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                  YOU ARE JUST A CALL AWAY
                </h5>

                <form className="mb-[30px]" onSubmit={handleSubmit(onSubmit)}>
                  <m.div
                    className="row justify-center"
                    {...{ ...fadeIn, transition: { delay: 0.6 } }}
                  >
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="name"
                          className="rounded-[5px] relative py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.name?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="email"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your email address"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                              message: "Enter valid email",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.email?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="number"
                          name="phone"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your phone number"
                          onKeyDown={handleKeyDown}
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "Phone number is required",
                            },
                            pattern: {
                              value:
                                /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                              message: "Enter valid phone number",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.phone?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="address"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your address"
                          {...register("address", {
                            required: {
                              value: true,
                              message: "Address is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.address?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="stream"
                          className="rounded-[5px] py-[13px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Subject"
                          {...register("stream", {
                            required: {
                              value: true,
                              message: "Stream is required",
                            },
                            value: "Subject",
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.stream?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <textarea
                          type="text"
                          rows={3}
                          name="message"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your message"
                          {...register("message", {
                            required: {
                              value: true,
                              message: "Message is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-10px] translate-x-[10px]">
                          {errors.message?.message}
                        </div>
                      </div>
                    </Col>
                  </m.div>

                  <Buttons
                    type="submit"
                    className={`btn-fill text-sm leading-none font-medium tracking-[1px] !py-[17px] px-[32px] rounded-[4px] w-full uppercase mb-[5px] ${
                      formLoading ? "loading" : ""
                    }`}
                    themeColor="#f78c1f"
                    color="#fff"
                    size="lg"
                    title="Request a call schedule"
                  />
                </form>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </m.section>
      {/* enquiry form section end */}
    </>
  );
}

export default DirectAdmissionInBptInPune;
